const URL = 'https://raw.githubusercontent.com/alexeikravchuk/rslang-data/master/';

export { URL };
